import { render, staticRenderFns } from "./PortalAboutView.vue?vue&type=template&id=3ad20614&scoped=true&"
import script from "./PortalAboutView.vue?vue&type=script&lang=js&"
export * from "./PortalAboutView.vue?vue&type=script&lang=js&"
import style0 from "./PortalAboutView.vue?vue&type=style&index=0&id=3ad20614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad20614",
  null
  
)

export default component.exports